var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { InitialInfoView } from "./view";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { quoteAllClearData } from "../../store/generateQuote/actions";
import { postCalculationsAPI } from "../../resources/helperAPAP/calculations";
import "./style.css";
import showToast from "../../services/toast";
import { hasPermission } from "../../services/getNavigationPages";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
import { useCataloguesGetAll } from "../../fnx/catalogue/catalogueGetAll";
import { updateStepByPath } from "ah_utility/workflow";
import { backStepByPath } from "../../utils/updateStepBack";
import { insertIntoStepInformation } from "../../utils/upsertStepInformation";
import { useCompleteStep } from "../../utils/responseComplete";
import { getStepNavigation } from "../../utils/nextBackStep";
import { useGetInformationSteps } from "ah_utility/workflow";
import { useGetSteps } from "../../utils/getSteps";
import { useGetSummary } from "../../utils/getSummary";
import { formatNumberCustom } from "../../utils/getPrice";
import { addToSummary } from "ah_utility/fnxUtils";
export var InitialInfoPage = function () {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var steps = useGetSteps();
    var _a = useState([]), filters = _a[0], setFilters = _a[1];
    var _b = React.useState([]), breadCrumbs = _b[0], setBreadCrumbs = _b[1];
    var _c = useState(true), showNextDisabled = _c[0], setShowNextDisabled = _c[1];
    var _d = useState("0.00"), valorEstimado = _d[0], setValorEstimado = _d[1];
    var _e = useState("DOP"), currency = _e[0], setCurrency = _e[1];
    var _f = useState(30150000), maxValue = _f[0], setMaxValue = _f[1];
    var _g = useState([
        { id: "A", name: "Anual", code: "ANU" },
    ]), cataloguePaymentMode = _g[0], setCataloguePaymentMode = _g[1];
    var _h = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _h[0], setSeeToast = _h[1];
    var _j = useCataloguesGetAll(true, "CATALOG_PAYMENT_MODE"), responseCatalogues = _j.responseCatalogues, errorCatalogues = _j.errorCatalogues, loadingCatalogues = _j.loadingCatalogues;
    var pathname = useLocation().pathname;
    var _k = useCompleteStep(), runComplete = _k.runComplete, loadingComplete = _k.loadingComplete;
    var _l = useGetInformationSteps(pathname), instanceId = _l.instanceId, workFlowId = _l.workFlowId, currentStep = _l.currentStep, nextStep = _l.nextStep;
    var _m = useState(false), loading = _m[0], setLoading = _m[1];
    var permissions = {
        create: hasPermission("initial-info"),
    };
    var summary = useGetSummary();
    var dataNavigation = React.useState(getStepNavigation(pathname))[0];
    useEffect(function () {
        dispatch(quoteAllClearData());
    }, []);
    useEffect(function () {
        if (responseCatalogues &&
            Array.isArray(responseCatalogues) &&
            responseCatalogues.length > 0) {
            var listCatalogues = responseCatalogues.map(function (item) { return ({
                id: item.id,
                code: item.code,
                name: item.description,
            }); });
            setCataloguePaymentMode(listCatalogues);
            console.log("Current cataloguePaymentMode:", cataloguePaymentMode);
        }
    }, [responseCatalogues, loadingCatalogues]);
    useEffect(function () {
        var _a;
        var newMap = (_a = summary === null || summary === void 0 ? void 0 : summary.data) === null || _a === void 0 ? void 0 : _a.map(function (e) { return ({
            name: e.label,
            label: e.value,
            type: "label",
        }); });
        setFilters(newMap);
    }, [summary]);
    var handleClickPrevious = function (e) {
        backStepByPath(pathname);
        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.back));
    };
    var calculateAge = function (dateString) {
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 ||
            (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };
    var calculateInterestRate = function (currency) {
        var interestRate = 0;
        if (currency === "DOP") {
            interestRate = 7;
        }
        else {
            interestRate = 3;
        }
        return interestRate;
    };
    var handleClickNext = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var data_1, res, prevStep, currentStep_1, nextStep_1, err_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setLoading(true);
                    if (!e.data) return [3 /*break*/, 1];
                    data_1 = {
                        age: calculateAge(e.data.dateBirth),
                        interval: e.data.policyDuration,
                        interestRate: calculateInterestRate(e.data.currency.id),
                        utility: 5.0,
                        coverageAmount: e.data.InsureAmount,
                        reinsuranceRatePerThousand: 1,
                        productType: e.data.planType.id,
                        gender: e.data.sexType.id,
                        currency: e.data.currency.id,
                        smokes: e.data.smoke.id,
                        paymentMode: e.data.paymentMode.code,
                    };
                    postCalculationsAPI(data_1)
                        .then(function (response) {
                        var _a, _b, _c, _d, _e, _f;
                        setLoading(false);
                        var premium = (_a = response.data[0]) === null || _a === void 0 ? void 0 : _a.premiumRate;
                        var formattedPremium = new Intl.NumberFormat("es-DO", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }).format(premium);
                        var newPrice = parseFloat(formattedPremium.replace(/,/g, "")) * 1.16;
                        updateStepByPath(pathname, e.data); // GUARDO LA DATA EN EL STEP DETAILS
                        var roundedPrice = Math.round(newPrice);
                        try {
                            var insuredAmount = formatNumberCustom((_b = data_1.coverageAmount) !== null && _b !== void 0 ? _b : "");
                            var estimatedValue = formatNumberCustom(roundedPrice !== null && roundedPrice !== void 0 ? roundedPrice : "");
                            addToSummary([
                                {
                                    label: "Tipo de plan",
                                    value: (_c = e.data.planType.name) !== null && _c !== void 0 ? _c : "",
                                },
                                {
                                    label: "Fuma",
                                    value: (_d = e.data.smoke.name) !== null && _d !== void 0 ? _d : "",
                                },
                                {
                                    label: "Duración de póliza",
                                    value: "".concat((_e = data_1.interval) !== null && _e !== void 0 ? _e : "", " a\u00F1os"),
                                },
                                {
                                    label: "Moneda",
                                    value: (_f = e.data.currency.name) !== null && _f !== void 0 ? _f : "",
                                },
                                {
                                    label: "Suma asegurada",
                                    value: insuredAmount,
                                },
                            ]);
                        }
                        catch (summaryError) {
                            console.error("Error en addToSummary:", summaryError);
                        }
                        // Round to nearest whole number
                        setValorEstimado(roundedPrice.toString());
                        e.data.premium = roundedPrice.toString(); // with taxes
                        e.data.premiumWithoutTaxes = premium ? premium.toFixed(2) : "0.00";
                        if (premium === 0 || premium === null || premium === undefined) {
                            setSeeToast({
                                show: true,
                                message: "El valor estimado debe ser mayor a 0.00",
                                type: typeAlert.warning,
                            });
                            setShowNextDisabled(true);
                            return;
                        }
                        setSeeToast({
                            show: true,
                            message: "Los datos han sido guardados",
                            type: typeAlert.success,
                        });
                        setShowNextDisabled(false);
                    })
                        .catch(function (error) {
                        console.log("postCalculationsAPI error", error);
                        setLoading(false);
                        setShowNextDisabled(true);
                        console.log("error", error);
                        setSeeToast({
                            show: true,
                            message: "Error al realizar los cálculos",
                            type: typeAlert.error,
                        });
                    });
                    return [3 /*break*/, 4];
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, runComplete({
                            workFlowId: workFlowId,
                            instanceId: instanceId,
                            currentStep: currentStep,
                            nextStep: nextStep,
                        })];
                case 2:
                    res = _d.sent();
                    if (res) {
                        prevStep = (_a = res.upcomingFormStep) === null || _a === void 0 ? void 0 : _a.prevSteps[0];
                        currentStep_1 = (_b = res.upcomingFormStep) === null || _b === void 0 ? void 0 : _b.id;
                        nextStep_1 = (_c = res.upcomingFormStep) === null || _c === void 0 ? void 0 : _c.nextSteps[0];
                        insertIntoStepInformation({
                            stepKey: pathname,
                            data: {
                                currentStep: currentStep_1,
                                nextStep: nextStep_1,
                                prevStep: prevStep,
                            },
                        });
                        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.next));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _d.sent();
                    console.error("Error completing step:", err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onChangeCurrency = function (data) {
        if (data.id === "DOP") {
            setCurrency("DOP");
            setMaxValue(18000000);
        }
        else {
            setCurrency("USD");
            setMaxValue(300000);
        }
    };
    var handlePaymentMode = function (data) {
        console.log("handlePaymentMode", data);
    };
    return (_jsxs(React.Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loading || loadingCatalogues || loadingComplete, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Calculando..." }), _jsx(InitialInfoView, { title: "Datos iniciales", steps: steps, breadcrumbs: breadCrumbs || [], stepProgress: steps || [], previousLabel: "Anterior", nextLabel: "Siguiente", nextDisabled: showNextDisabled, onClickNext: handleClickNext, onClickPrevious: handleClickPrevious, filters: filters || [], minHeightGrid: "100vh", resumeDescription: "Valor estimado", resumeValue: "RD$ ".concat(valorEstimado), titleContent: "Datos iniciales", titleContentSectionB: "Coberturas opcionales", titleContentSectionC: "Tipo de NCF requerido", lblPlanType: "Tipo de plan", lblDateBirth: "Fecha de nacimiento", lblSex: "Sexo", listPlanType: [{ id: "TEMPORAL", name: "Temporal" }], listSex: [
                    { id: "M", name: "Masculino" },
                    { id: "F", name: "Femenino" },
                ], lblSmoke: "Fuma", listSmoke: [
                    { id: "N", name: "NO" },
                    { id: "S", name: "SI" },
                ], listCurrency: [{ id: "DOP", name: "DOP" }], lblCurrency: "Moneda", titleYearSlider: "Duración de la Póliza", subtitleYearSlider: "Años", minValueYearSlider: 5, maxValueYearSlider: 20, widthYearSlider: 730, stepYearSlider: 5, defaultValueYearSlider: 5, fontSizeSubtitleYearSlider: "14px", fontSizeTitleYearSlider: "14px", inputFontSizeYearSlider: "12px", inputWidthSizeYearSlider: "40px", titleDecimalSlider: "Suma asegurada", subtitleDecimalSlider: currency, minValueDecimalSlider: 100, maxValueDecimalSlider: maxValue, widthDecimalSlider: 730, stepDecimalSlider: 100, defaultValueDecimalSlider: 8000, fontSizeSubtitleDecimalSlider: "14px", fontSizeTitleDecimalSlider: "14px", inputFontSizeDecimalSlider: "12px", inputWidthSizeDecimalSlider: "170px", onChangeCurrency: onChangeCurrency, lblPaymentMode: "Modalidad de pago", listPaymentMode: cataloguePaymentMode, handlePaymentMode: handlePaymentMode, showInfo: true, hideFilter: false })] }));
};
